'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var _styled = _interopDefault(require('@emotion/styled-base'));
var PropTypes = _interopDefault(require('prop-types'));

function IconAlert() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 50 47", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M28.572 38.837c0 .509-.39.932-.893.932H22.32c-.502 0-.893-.423-.893-.932v-5.366c0-.509.39-.933.893-.933h5.358c.502 0 .893.424.893.933v5.366zm-.056-10.564c-.028.368-.446.65-.949.65h-5.162c-.53 0-.949-.282-.949-.65l-.474-12.908c0-.17.083-.452.279-.593.167-.141.418-.31.67-.31h6.139c.25 0 .502.169.67.31.195.141.278.367.278.537l-.502 12.964zm-.39-26.38A3.545 3.545 0 0 0 25 0a3.545 3.545 0 0 0-3.125 1.892L.444 41.662c-.614 1.101-.586 2.457.055 3.559A3.564 3.564 0 0 0 3.57 47H46.43a3.564 3.564 0 0 0 3.07-1.78c.641-1.101.67-2.457.055-3.558l-21.43-39.77z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  );
}

function IconBlitz() {
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 40 42"
    },
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "blitz1", width: "35", height: "30", x: "8", y: "12", rx: "15" }),
      React.createElement(
        "filter",
        {
          id: "blitz2",
          height: "123.3%",
          x: "-7.1%",
          y: "-8.3%",
          filterUnits: "objectBoundingBox"
        },
        React.createElement("feOffset", {
          dx: "1",
          dy: "1",
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }),
        React.createElement("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: "1"
        }),
        React.createElement("feComposite", {
          "in": "shadowBlurOuter1",
          in2: "SourceAlpha",
          operator: "out",
          result: "shadowBlurOuter1"
        }),
        React.createElement("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", transform: "translate(-6 -5)" },
      React.createElement("use", { fill: "#000", filter: "url(#blitz2)", xlinkHref: "#blitz1" }),
      React.createElement("rect", {
        width: "32",
        height: "27",
        x: "9.5",
        y: "13.5",
        fill: "#F4C840",
        stroke: "#50093B",
        strokeLinejoin: "square",
        strokeWidth: "3",
        rx: "13.5"
      }),
      React.createElement("rect", { width: "21", height: "18", x: "15", y: "18", fill: "#971C72", rx: "9" }),
      React.createElement("path", {
        fill: "#F9E29A",
        stroke: "#A24A1B",
        d: "M12.731 28.864l8.302.397-13.826 16.45 32.765-22.874-11.804.063L40.602 6.41z"
      })
    )
  );
}

function IconBell() {
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 41 41"
    },
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { fill: "#fff" },
        React.createElement("circle", { cx: "20.5", cy: "20.5", r: "20.5" }),
        React.createElement("circle", { cx: "20.5", cy: "20.5", fillRule: "nonzero", r: "20.5" })
      ),
      React.createElement("path", {
        d: "m14.25 25.8194444v1.1805556c0 1.5187831-1.2312169 2.75-2.75 2.75h-1c-1.51878306 0-2.75-1.2312169-2.75-2.75v-1.1805556zm5-4.0347437.5347222.0000215c1.085393 0 1.9652778.8798849 1.9652778 1.9652778s-.8798848 1.9652778-1.9652778 1.9652778h-17.56944442c-1.08539295 0-1.96527778-.8798849-1.96527778-1.9652778s.87988483-1.9652778 1.96524756-1.9652778l.53475244-.0000215v-9.1597007c0-.2384467.0305272-.4735469.07301069-.6150651.55366942-3.91485218 4.08130078-6.99604601 8.17698931-6.99604601 4.0959199 0 7.6234456 3.08145415 8.158282 6.90773761.0608137.2272808.091718.4634723.091718.7033735zm-8-21.5347007c.9664983 0 1.75.78350169 1.75 1.75v1.64583333c0 .96649832-.7835017 1.75-1.75 1.75h-.5c-.96649831 0-1.75-.78350168-1.75-1.75v-1.64583333c0-.96649831.78350169-1.75 1.75-1.75z",
        stroke: "#90959c",
        strokeWidth: "1.5",
        transform: "translate(10 6)"
      })
    )
  );
}

function IconBellPressed() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 41 41", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement(
      "defs",
      null,
      React.createElement("circle", { id: "a", cx: "20.5", cy: "20.5", r: "20.5" }),
      React.createElement(
        "filter",
        { id: "b", height: "109.8%", width: "109.8%", x: "-4.9%", y: "-4.9%" },
        React.createElement("feGaussianBlur", {
          "in": "SourceAlpha",
          result: "shadowBlurInner1",
          stdDeviation: "1.5"
        }),
        React.createElement("feOffset", {
          dx: "0",
          dy: "1",
          "in": "shadowBlurInner1",
          result: "shadowOffsetInner1"
        }),
        React.createElement("feComposite", {
          "in": "shadowOffsetInner1",
          in2: "SourceAlpha",
          k2: "-1",
          k3: "1",
          operator: "arithmetic",
          result: "shadowInnerInner1"
        }),
        React.createElement("feColorMatrix", {
          "in": "shadowInnerInner1",
          type: "matrix",
          values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
        })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        null,
        React.createElement("use", { fill: "#fff", fillRule: "evenodd", xlinkHref: "#a" }),
        React.createElement("use", { fill: "#000", filter: "url(#b)", xlinkHref: "#a" })
      ),
      React.createElement("path", {
        d: "m13.25 24.8194444v1.1805556c0 1.5187831-1.2312169 2.75-2.75 2.75h-1c-1.51878306 0-2.75-1.2312169-2.75-2.75v-1.1805556zm5-4.0347437.5347222.0000215c1.085393 0 1.9652778.8798849 1.9652778 1.9652778s-.8798848 1.9652778-1.9652778 1.9652778h-17.56944442c-1.08539295 0-1.96527778-.8798849-1.96527778-1.9652778s.87988483-1.9652778 1.96524756-1.9652778l.53475244-.0000215v-9.1597007c0-.2384467.0305272-.4735469.07301069-.6150651.55366942-3.91485218 4.08130078-6.99604601 8.17698931-6.99604601 4.0959199 0 7.6234456 3.08145415 8.158282 6.90773761.0608137.2272808.091718.4634723.091718.7033735zm-8-21.5347007c.9664983 0 1.75.78350169 1.75 1.75v1.64583333c0 .96649832-.7835017 1.75-1.75 1.75h-.5c-.96649831 0-1.75-.78350168-1.75-1.75v-1.64583333c0-.96649831.78350169-1.75 1.75-1.75z",
        stroke: "#90959c",
        strokeWidth: "1.5",
        transform: "translate(11 7)"
      })
    )
  );
}

function IconCaretDown() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z",
      fill: "currentColor"
    })
  );
}

function IconCheck() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M41.797 19.727a2.04 2.04 0 0 1-.586 1.464L23.535 38.867c-.39.39-.944.619-1.497.619a2.13 2.13 0 0 1-1.465-.619L8.789 27.083a2.04 2.04 0 0 1-.586-1.465c0-.553.195-1.106.586-1.497l2.962-2.93a2.07 2.07 0 0 1 1.465-.618 2.07 2.07 0 0 1 1.465.618l7.357 7.357L35.319 15.3a2.07 2.07 0 0 1 1.465-.618 2.07 2.07 0 0 1 1.465.618l2.962 2.93c.39.39.586.944.586 1.498zM50 25C50 11.198 38.802 0 25 0S0 11.198 0 25s11.198 25 25 25 25-11.198 25-25z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  );
}

function IconChevronDown() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z",
      fill: "currentColor"
    })
  );
}

function IconChevronLeft() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1427 301L896 832l531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19L429 877q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z",
      fill: "currentColor"
    })
  );
}

function IconChevronRight() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45L531 45q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z",
      fill: "currentColor"
    })
  );
}

function IconChevronUp() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M109 984l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5l-166 165q-19 19-45 19t-45-19L896 709l-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5z",
      fill: "currentColor"
    })
  );
}

function IconPlus() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" },
    React.createElement("path", {
      fill: "currentColor",
      d: "m18 10.2h-7.8v7.8h-2.4v-7.8h-7.8v-2.4h7.8v-7.8h2.4v7.8h7.8z"
    })
  );
}

function IconMinus() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 4" },
    React.createElement("path", {
      d: "m0 0h18v2.362h-18z",
      fill: "currentColor",
      transform: "translate(0 .82)"
    })
  );
}

function IconCheckCircle() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 62" },
    React.createElement(
      "g",
      { fill: "currentColor" },
      React.createElement("path", { d: "M58.613 25.45a2.585 2.585 0 0 0-2.585 2.586v2.604c-.004 6.792-2.652 13.176-7.458 17.976-4.802 4.797-11.184 7.438-17.97 7.438h-.015C16.563 56.046 5.163 44.632 5.17 30.61c.004-6.792 2.653-13.176 7.459-17.976 4.802-4.797 11.183-7.438 17.97-7.438h.015a25.27 25.27 0 0 1 10.335 2.202 2.585 2.585 0 1 0 2.104-4.723A30.406 30.406 0 0 0 30.617.025h-.018c-8.166 0-15.846 3.18-21.624 8.95C3.192 14.753.005 22.436 0 30.609-.005 38.78 3.174 46.467 8.95 52.25c5.776 5.782 13.458 8.97 21.632 8.974h.018c8.166 0 15.846-3.178 21.624-8.95 5.783-5.776 8.97-13.458 8.975-21.633v-2.605a2.585 2.585 0 0 0-2.586-2.585z" }),
      React.createElement("path", { d: "M63.243 3.6a2.585 2.585 0 0 0-3.656 0L30.599 32.588l-6.576-6.576a2.585 2.585 0 1 0-3.656 3.656l8.404 8.404a2.577 2.577 0 0 0 1.828.757c.662 0 1.324-.252 1.829-.757L63.243 7.256a2.585 2.585 0 0 0 0-3.656z" })
    )
  );
}

function IconCheckCircleEmpty() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 62" },
    React.createElement("path", {
      d: "M30.65,61.3 C13.7224724,61.3 0,47.5775276 0,30.65 C0,13.7224724 13.7224724,0 30.65,0 C47.5775276,0 61.3,13.7224724 61.3,30.65 C61.3,47.5775276 47.5775276,61.3 30.65,61.3 Z M30.5,56 C44.5832611,56 56,44.5832611 56,30.5 C56,16.4167389 44.5832611,5 30.5,5 C16.4167389,5 5,16.4167389 5,30.5 C5,44.5832611 16.4167389,56 30.5,56 Z",
      fill: "currentColor"
    })
  );
}

function IconCrown() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 23 20" },
    React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.837 3.122c-.008-.015-.108-.015-.12-.016a1.38 1.38 0 0 0-.31.009 1.705 1.705 0 0 0-.664.25c-.273.172-.443.467-.534.771a1.39 1.39 0 0 0-.056.509c.013.17.048.384.123.54.046.094.147.231.243.34.19.216.298.317.449.441-.634-.11-1.307-.212-1.93-.016a1.503 1.503 0 0 0-1.021 1.184c-.078.453.128 1.044.496 1.342.39.318.928.38 1.397.245.131-.04.504-.205.586-.323.019.175-.217.638-.437.911a5.263 5.263 0 0 1-.757.73c-.23.186-.532.353-.79.493-.888.47-1.968.563-2.971.46-.49-.049-1.021-.144-1.435-.347-.655-.323-1.396-.795-1.752-1.452a4.444 4.444 0 0 1-.404-1.017c.812.592 1.823.695 2.639.016.669-.555.898-1.52.55-2.3a1.786 1.786 0 0 0-1.242-1.006 2.234 2.234 0 0 0-.825-.024c-.132.022-.94.34-.833-.07.04-.145.283-.294.386-.397.588-.598.774-1.31.474-2.095-.26-.685-.839-1.2-1.577-1.321a1.876 1.876 0 0 0-.376-.02 2.265 2.265 0 0 0-.376.02c-.734.128-1.31.645-1.568 1.33-.297.79-.104 1.5.489 2.093.103.102.35.252.39.395.111.41-.7.095-.833.072a2.305 2.305 0 0 0-.826.029A1.785 1.785 0 0 0 7.189 5.91c-.344.783-.104 1.745.565 2.296.82.673 1.831.56 2.64-.036a4.29 4.29 0 0 1-.397 1.016c-.353.66-1.089 1.136-1.741 1.463-.413.207-.942.302-1.433.354-1.002.107-2.083.023-2.975-.442a5.608 5.608 0 0 1-.795-.486 5.433 5.433 0 0 1-.761-.727c-.223-.268-.462-.734-.442-.91.082.115.456.28.59.316.47.129 1.005.066 1.395-.255.364-.303.565-.894.484-1.347a1.503 1.503 0 0 0-1.027-1.18c-.623-.194-1.294-.087-1.928.028.152-.13.256-.229.446-.447.093-.11.197-.249.24-.343.074-.156.108-.372.12-.543a1.365 1.365 0 0 0-.059-.51c-.092-.304-.263-.596-.539-.77a1.673 1.673 0 0 0-.664-.246 1.383 1.383 0 0 0-.312-.008c-.01.001-.11.004-.117.017 0 0-.367.787-.31 2.344.07 1.893.47 3.952 1.256 5.685l.75 1.663.725 1.42a55.78 55.78 0 0 0 8.305.602 56.284 56.284 0 0 0 8.299-.657l.716-1.425.742-1.667c.774-1.74 1.158-3.802 1.214-5.696.048-1.557-.326-2.342-.326-2.342M2.45 18.795l.446-2.61a48.36 48.36 0 0 0 16.618-.054c.186 1.043.282 1.563.465 2.608a72.13 72.13 0 0 1-1.416.18c-5.132.61-9.974.612-15.126.002a43.096 43.096 0 0 1-.983-.123"
    })
  );
}

function IconCurrencyEur() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1360 1307l35 159q3 12-3 22.5t-17 14.5l-5 1q-4 2-10.5 3.5t-16 4.5-21.5 5.5-25.5 5-30 5-33.5 4.5-36.5 3-38.5 1q-234 0-409-130.5T511 1054h-95q-13 0-22.5-9.5T384 1022V909q0-13 9.5-22.5T416 877h66q-2-57 1-105h-67q-14 0-23-9t-9-23V626q0-14 9-23t23-9h98q67-210 243.5-338T1158 128q102 0 194 23 11 3 20 15 6 11 3 24l-43 159q-3 13-14 19.5t-24 2.5l-4-1q-4-1-11.5-2.5L1261 364l-22.5-3.5-26-3-29-2.5-29.5-1q-126 0-226 64T778 594h468q16 0 25 12 10 12 7 26l-24 114q-5 26-32 26H734q-3 37 0 105h459q15 0 25 12 9 12 6 27l-24 112q-2 11-11 18.5t-20 7.5H782q48 117 149.5 185.5T1160 1308q18 0 36-1.5t33.5-3.5 29.5-4.5 24.5-5 18.5-4.5l12-3 5-2q13-5 26 2 12 7 15 21z",
      fill: "currentColor"
    })
  );
}

function IconCurrencyGbp() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 260 422", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M121.696 257.492l1.432 39.195c-.382 23.46-5.727 41.962-16.035 55.504H260V422H.573v-69.809h21.19c9.353-2.86 14.507-14.782 15.462-35.763l.286-14.877-1.145-44.06H0v-67.806h34.648L32.93 124.74c0-38.528 10.308-68.95 30.925-91.266C84.47 11.158 111.865 0 146.035 0c35.125 0 62.757 10.681 82.897 32.043 20.14 21.363 30.209 50.545 30.209 87.548h-79.89c0-16.022-2.911-28.325-8.733-36.908-5.823-8.583-13.983-12.874-24.483-12.874-8.017 0-14.842 4.577-20.473 13.733-5.632 9.155-8.447 22.888-8.447 41.198l2.29 64.945h71.586v67.807h-69.295z", fill: "currentColor" })
  );
}

function IconCurrencyNok() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2706 1792" },
    React.createElement("path", {
      fillRule: "evenodd",
      d: "M1453.059 1792h-388.28L748.68 1346.489l-92.092 102.044V1792H338V0h318.588v1030.4l378.324-433.067h378.323l-462.948 520.178L1453.059 1792zm477.882-973.156c82.136-151.822 214.052-226.488 438.059-241.422v378.311c-74.67-19.91-146.85-19.91-219.03 0-114.492 32.356-219.029 141.867-219.029 336V1792h-318.588V597.333h318.588v221.511z"
    })
  );
}

function IconCurrencySek() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2706 1792" },
    React.createElement("path", {
      fillRule: "evenodd",
      d: "M1453.059 1792h-388.28L748.68 1346.489l-92.092 102.044V1792H338V0h318.588v1030.4l378.324-433.067h378.323l-462.948 520.178L1453.059 1792zm477.882-973.156c82.136-151.822 214.052-226.488 438.059-241.422v378.311c-74.67-19.91-146.85-19.91-219.03 0-114.492 32.356-219.029 141.867-219.029 336V1792h-318.588V597.333h318.588v221.511z"
    })
  );
}

function IconCurrencyUsd() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M1362 1185q0 153-99.5 263.5T1004 1585v175q0 14-9 23t-23 9H837q-13 0-22.5-9.5T805 1760v-175q-66-9-127.5-31T576 1509.5t-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25T733 948.5t-62.5-31T614 882t-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134V32q0-13 9.5-22.5T837 0h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5T1265 302t39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26T921 430q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z",
      fill: "currentColor"
    })
  );
}

function IconClose() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14" },
    React.createElement("path", {
      fill: "currentColor",
      d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
    })
  );
}

function IconClock() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
    React.createElement(
      "g",
      { fill: "#a8a8a8", fillRule: "evenodd" },
      React.createElement("path", {
        fillRule: "nonzero",
        d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14.316A6.323 6.323 0 0 1 1.684 8 6.323 6.323 0 0 1 8 1.684 6.323 6.323 0 0 1 14.316 8 6.323 6.323 0 0 1 8 14.316z"
      }),
      React.createElement("path", { d: "M12.327 7.916H9.39a1.342 1.342 0 0 0-.427-.454V3.714C8.963 3.32 8.662 3 8.29 3c-.372 0-.673.32-.673.714v3.748A1.39 1.39 0 0 0 7 8.63C7 9.386 7.579 10 8.29 10c.465 0 .873-.263 1.1-.655h2.937c.372 0 .673-.32.673-.715 0-.394-.301-.714-.673-.714z" })
    )
  );
}

function IconEye() {
    return React.createElement(
        "svg",
        { viewBox: "0 0 50 32", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M46.429 16C41.657 23.333 33.956 28.444 25 28.444c-8.956 0-16.657-5.11-21.429-12.444 2.651-4.083 6.278-7.583 10.631-9.806a12.304 12.304 0 0 0-1.702 6.25c0 6.862 5.608 12.445 12.5 12.445s12.5-5.583 12.5-12.445c0-2.194-.586-4.36-1.702-6.25 4.353 2.223 7.98 5.723 10.63 9.806zM26.339 5.333c0 .723-.614 1.334-1.339 1.334-3.18 0-5.804 2.61-5.804 5.777 0 .723-.613 1.334-1.339 1.334-.725 0-1.34-.611-1.34-1.334C16.518 7.806 20.34 4 25 4c.725 0 1.34.611 1.34 1.333zM50 16c0-.694-.223-1.333-.558-1.917C44.308 5.694 34.905 0 25 0S5.692 5.694.558 14.083C.223 14.667 0 15.306 0 16s.223 1.333.558 1.917C5.692 26.306 15.095 32 25 32s19.308-5.667 24.442-14.083c.335-.584.558-1.223.558-1.917z", fill: "currentColor", fillRule: "evenodd" })
    );
}

function IconEyeSlash() {
    return React.createElement(
        "svg",
        { viewBox: "0 0 50 38", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M15.485 29.603C10.575 27.369 6.473 23.553 3.571 19c2.651-4.156 6.278-7.719 10.631-9.98a12.695 12.695 0 0 0-1.702 6.36c0 4.043 1.925 7.86 5.162 10.235l-2.177 3.987zM26.34 8.143c0 .735-.614 1.357-1.339 1.357-3.18 0-5.804 2.63-5.804 5.881 0 .735-.613 1.357-1.339 1.357-.725 0-1.34-.622-1.34-1.357 0-4.722 3.823-8.595 8.483-8.595.725 0 1.34.622 1.34 1.357zm10.129-5.4a.893.893 0 0 0-.447-.764C35.435 1.64 32.812 0 32.311 0a.888.888 0 0 0-.782.452l-1.507 2.743A27.232 27.232 0 0 0 25 2.715C14.704 2.714 6.083 8.453.558 17.048A3.684 3.684 0 0 0 0 19c0 .707.195 1.385.558 1.95 3.209 5.09 7.757 9.331 13.17 11.82-.28.48-1.228 2.007-1.228 2.46 0 .338.167.621.446.79.586.34 3.237 1.98 3.74 1.98.306 0 .613-.17.78-.452l1.368-2.517C24.72 24.372 30.552 13.656 36.44 2.997c.028-.057.028-.198.028-.254zM37.5 15.38c0-.792-.084-1.583-.223-2.375l-7.813 14.193c4.827-1.866 8.036-6.56 8.036-11.818zM50 19c0-.735-.195-1.329-.558-1.95-2.176-3.648-5.664-7.182-9.124-9.53l-1.758 3.168c3.153 2.205 5.804 5.06 7.869 8.312-4.353 6.842-11.245 11.847-19.364 12.554L25 35.286c8.398 0 15.932-3.874 21.4-10.235 1.089-1.273 2.177-2.658 3.042-4.1.363-.622.558-1.216.558-1.951z", fill: "currentColor", fillRule: "evenodd" })
    );
}

function IconFlagFinland() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
    React.createElement("path", { fill: "#fff", d: "M0 0h512v512H0z" }),
    React.createElement("path", { fill: "#003580", d: "M0 186.182h512v139.636H0z" }),
    React.createElement("path", { fill: "#003580", d: "M123.152 0h139.636v512H123.152z" })
  );
}

function IconFlagGermany() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
    React.createElement("path", { fill: "#ffce00", d: "M0 341.338h512.005v170.67H0z" }),
    React.createElement("path", { d: "M0 0h512.005v170.67H0z" }),
    React.createElement("path", { fill: "#d00", d: "M0 170.67h512.005v170.668H0z" })
  );
}

function IconFlagGreatBritain() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
    React.createElement(
      "g",
      { strokeWidth: "1pt" },
      React.createElement("path", { fill: "#006", d: "M-256 0H768.02v512.01H-256z" }),
      React.createElement("path", {
        d: "M-256 0v57.245l909.535 454.768H768.02V454.77L-141.515.003H-256zM768.02 0v57.242L-141.515 512.01H-256V454.77L653.535 0H768.02z",
        fill: "#fff"
      }),
      React.createElement("path", {
        d: "M170.675 0v512.01h170.67V0h-170.67zM-256 170.67v170.67H768.02V170.67H-256z",
        fill: "#fff"
      }),
      React.createElement("path", {
        d: "M-256 204.804v102.402H768.02V204.804H-256zM204.81 0v512.01h102.4V0h-102.4zM-256 512.01L85.34 341.34h76.324l-341.34 170.67H-256zM-256 0L85.34 170.67H9.016L-256 38.164V0zm606.356 170.67L691.696 0h76.324L426.68 170.67h-76.324zM768.02 512.01L426.68 341.34h76.324L768.02 473.85v38.161z",
        fill: "#c00"
      })
    )
  );
}

function IconFlagNorway() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
    React.createElement("path", { d: "M0 0h512v512H0z", fill: "#ef2b2d" }),
    React.createElement("path", { d: "M128 0h128v512H128z", fill: "#fff" }),
    React.createElement("path", { d: "M0 192h512v128H0z", fill: "#fff" }),
    React.createElement("path", { d: "M160 0h64v512h-64z", fill: "#002868" }),
    React.createElement("path", { d: "M0 224h512v64H0z", fill: "#002868" })
  );
}

function IconFlagSweden() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
    React.createElement(
      "g",
      { transform: "translate(-124.12 -7.622) scale(1.0433)" },
      React.createElement(
        "g",
        { fillRule: "evenodd", strokeWidth: "1pt" },
        React.createElement("path", {
          fill: "#006aa7",
          d: "M2.904 7.598h245.368v196.294H2.904zm0 294.132h245.368v196.295H2.904z"
        }),
        React.createElement("path", { fill: "#fecc00", d: "M2.904 203.78h245.368v98.147H2.904z" }),
        React.createElement("path", { fill: "#fecc00", d: "M247.262 7.318h98.147v490.735h-98.147z" }),
        React.createElement("path", { fill: "#fecc00", d: "M342.296 203.808h441.662v98.147H342.296z" }),
        React.createElement("path", {
          fill: "#006aa7",
          d: "M345.325 301.759h441.661v196.294H345.325zm0-294.161h441.661v196.294H345.325z"
        })
      )
    )
  );
}

function IconFullscreen() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 53 53", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M37.564 18.873l3.094 3.094c.258.258.602.408.967.408.172 0 .365-.043.537-.107.494-.215.838-.71.838-1.268v-9.625c0-.752-.623-1.375-1.375-1.375H32c-.559 0-1.053.344-1.268.86a1.325 1.325 0 0 0 .301 1.482l3.094 3.094-7.627 7.627-7.627-7.627 3.094-3.094c.408-.387.515-.988.3-1.483A1.378 1.378 0 0 0 21 10h-9.625c-.752 0-1.375.623-1.375 1.375V21c0 .559.344 1.053.86 1.268.15.064.343.107.515.107.365 0 .709-.15.967-.408l3.094-3.094 7.627 7.627-7.627 7.627-3.094-3.094a1.325 1.325 0 0 0-1.483-.3A1.374 1.374 0 0 0 10 32v9.625c0 .752.623 1.375 1.375 1.375H21c.559 0 1.053-.344 1.268-.86a1.325 1.325 0 0 0-.301-1.482l-3.094-3.094 7.627-7.627 7.627 7.627-3.094 3.094a1.325 1.325 0 0 0-.3 1.483c.214.515.708.859 1.267.859h9.625c.752 0 1.375-.623 1.375-1.375V32c0-.559-.344-1.053-.838-1.268a1.352 1.352 0 0 0-1.504.301l-3.094 3.094-7.627-7.627 7.627-7.627z",
      fill: "currentColor",
      fillRule: "evenodd" })
  );
}

function IconHome() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 495.398 495.398", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement(
      "g",
      { fill: "currentColor" },
      React.createElement("path", { d: "M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391     v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158     c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747     c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z" }),
      React.createElement("path", { d: "M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401     c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79     c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z" })
    )
  );
}

function IconInfo() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M33.333 40.625c0 .586-.455 1.042-1.041 1.042H17.708a1.028 1.028 0 0 1-1.041-1.042v-5.208c0-.586.455-1.042 1.041-1.042h3.125V23.958h-3.125a1.028 1.028 0 0 1-1.041-1.041v-5.209c0-.586.455-1.041 1.041-1.041h10.417c.586 0 1.042.455 1.042 1.041v16.667h3.125c.586 0 1.041.456 1.041 1.042v5.208zm-4.166-29.167c0 .586-.456 1.042-1.042 1.042h-6.25a1.028 1.028 0 0 1-1.042-1.042V6.25c0-.586.456-1.042 1.042-1.042h6.25c.586 0 1.042.456 1.042 1.042v5.208zM50 25C50 11.198 38.802 0 25 0S0 11.198 0 25s11.198 25 25 25 25-11.198 25-25z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  );
}

function IconMagnifyingGlass() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14" },
    React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.006 8.805h-.633l-.224-.216a5.18 5.18 0 0 0 1.257-3.386 5.203 5.203 0 1 0-5.203 5.203 5.18 5.18 0 0 0 3.386-1.257l.216.224v.633L12.807 14 14 12.807l-3.994-4.002zm-4.803 0a3.597 3.597 0 0 1-3.602-3.602 3.597 3.597 0 0 1 3.602-3.602 3.597 3.597 0 0 1 3.602 3.602 3.597 3.597 0 0 1-3.602 3.602z"
    })
  );
}

function IconTimes() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 29 29", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M29 23.337c0-.61-.244-1.22-.684-1.66L21.14 14.5l7.176-7.177c.44-.44.684-1.05.684-1.66 0-.61-.244-1.22-.684-1.66l-3.32-3.32A2.367 2.367 0 0 0 23.337 0c-.61 0-1.22.244-1.66.684L14.5 7.86 7.323.684A2.367 2.367 0 0 0 5.663 0c-.61 0-1.22.244-1.66.684l-3.32 3.32C.245 4.442 0 5.052 0 5.663c0 .61.244 1.22.684 1.66L7.86 14.5.684 21.677c-.44.44-.684 1.05-.684 1.66 0 .61.244 1.22.684 1.66l3.32 3.32c.439.439 1.049.683 1.66.683.61 0 1.22-.244 1.66-.684L14.5 21.14l7.177 7.176c.44.44 1.05.684 1.66.684.61 0 1.22-.244 1.66-.684l3.32-3.32c.439-.439.683-1.049.683-1.66z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  );
}

function IconNavigation() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M0 0h18v4H0V0zm0 7h18v4H0V7zm0 7h18v4H0v-4z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  );
}

function IconDealer() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement(
      "g",
      { fill: "currentColor" },
      React.createElement("path", { d: "M4.383 2.386l1.165-.56V7.14c0 .23.205.416.46.416.253 0 .46-.186.46-.416V1.81l1.163.572a.36.36 0 0 0 .458-.116c.154-.237.347-.621.347-1.055 0-.434-.193-.818-.347-1.055A.362.362 0 0 0 7.631.04L6.03.827 4.383.037a.362.362 0 0 0-.456.116C3.773.39 3.58.776 3.58 1.21c0 .435.194.821.348 1.058a.362.362 0 0 0 .456.117z" }),
      React.createElement("path", { d: "M11.566 1.903l-1.75-.56a.425.425 0 0 0-.303.017.364.364 0 0 0-.197.21l-2.979 8.652a.29.29 0 0 1-.278.185.29.29 0 0 1-.278-.185l-2.98-8.656a.364.364 0 0 0-.195-.21.425.425 0 0 0-.3-.019l-1.85.57c-.257.079-.43.298-.43.544v8.946c0 .317.284.575.635.575h10.693c.35 0 .635-.258.635-.575V2.445c0-.243-.17-.46-.423-.542zm-.942 8.268c0 .124-.111.224-.248.224H8.025c-.137 0-.248-.1-.248-.224v-.46c0-.124.111-.224.248-.224h2.351c.137 0 .248.1.248.224v.46z" })
    )
  );
}

function IconRoulette() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" },
    React.createElement(
      "g",
      { fill: "none", fillRule: "nonzero" },
      React.createElement("path", {
        fill: "currentColor",
        d: "M12.355 1.799a7.482 7.482 0 0 0-10.556.82 7.487 7.487 0 1 0 10.556-.82zm1.451 7.86l-2.288-.79c.308-.898.304-1.873 0-2.763l2.286-.787c.181.528.296 1.083.34 1.654a6.66 6.66 0 0 1-.338 2.686zm.129-4.403v-.001.001zm-1.413-2.151L10.7 4.687a4.24 4.24 0 0 0-2.393-1.382l.46-2.36a6.648 6.648 0 0 1 3.755 2.16zM5.215 1.21A6.59 6.59 0 0 1 6.21.94l.46 2.366a4.242 4.242 0 0 0-2.394 1.38L2.452 3.1a6.662 6.662 0 0 1 2.763-1.889zM1.168 5.315l2.288.789a4.276 4.276 0 0 0-.001 2.763l-2.288.788a6.718 6.718 0 0 1 0-4.34zm1.28 6.557l1.825-1.586a4.24 4.24 0 0 0 2.393 1.382l-.461 2.374a6.664 6.664 0 0 1-3.757-2.17zm7.31 1.897a6.678 6.678 0 0 1-.993.273l-.46-2.373a4.242 4.242 0 0 0 2.393-1.381l1.824 1.586a6.675 6.675 0 0 1-2.764 1.895z"
      }),
      React.createElement(
        "g",
        { fill: "currentColor", transform: "translate(1 2)" },
        React.createElement("circle", { cx: "3.716", cy: ".702", r: "1" }),
        React.createElement("circle", { cx: ".957", cy: "5.494", r: "1" }),
        React.createElement("circle", { cx: "3.728", cy: "10.279", r: "1" }),
        React.createElement("circle", { cx: "9.258", cy: "10.272", r: "1" }),
        React.createElement("circle", { cx: "12.016", cy: "5.479", r: "1" }),
        React.createElement("circle", { cx: "9.245", cy: ".694", r: "1" })
      )
    )
  );
}

function IconRGLimits() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 43 43", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "M18.262 38.235c-9.418 0-17.071-7.653-17.071-17.071S8.844 4.092 18.262 4.092c9.419 0 17.072 7.653 17.072 17.072S27.68 38.235 18.262 38.235z",
      fill: "#FFF"
    }),
    React.createElement("path", {
      d: "M18.262 4.933c8.999 0 16.23 7.316 16.23 16.23 0 8.999-7.316 16.231-16.23 16.231-8.998 0-16.23-7.316-16.23-16.23 0-8.999 7.232-16.23 16.23-16.23m0-1.683C8.423 3.251.35 11.241.35 21.164c0 9.839 7.99 17.912 17.912 17.912 9.84 0 17.913-7.99 17.913-17.912C36.09 11.24 28.102 3.25 18.262 3.25z",
      fill: "#009739"
    }),
    React.createElement("path", {
      d: "M13.385 10.483l6.475 10.26m-7.653 5.719l7.737-5.382",
      fill: "#FFF",
      stroke: "#009739",
      strokeWidth: "3.871",
      strokeLinecap: "round",
      strokeMiterlimit: "10"
    }),
    React.createElement("circle", { r: "10.848", cy: "28.9", cx: "31.802", fill: "#009739" }),
    React.createElement("path", {
      d: "M25.663 23.518h2.27v4.541l3.532-4.54h2.86l-4.037 5.13 4.205 5.634h-2.775l-3.785-5.046v5.046h-2.27V23.518zm11.605 3.7v1.01c.168-.337.42-.589.757-.841.252-.169.504-.337.757-.337h.42v2.27c-.168 0-.336-.083-.504-.083-.42 0-.757.168-1.01.42-.252.337-.336.757-.336 1.262v3.111H35.25v-6.98h2.018v.168z",
      fill: "#FFF"
    }),
    React.createElement("path", {
      d: "M4.387 21.164h2.018M18.43 9.138V7.12m-.169 28.508V33.61",
      stroke: "#009739",
      strokeWidth: "1.935",
      strokeLinecap: "round",
      strokeMiterlimit: "10"
    })
  );
}

function IconRGPause() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 43 43", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", {
      d: "m42.800001,21.55c0,11.7 -9.5,21.2 -21.3,21.2c-11.7,0 -21.3,-9.5 -21.3,-21.3c0.1,-11.7 9.6,-21.2 21.3,-21.2c11.8,0 21.3,9.5 21.3,21.3z",
      fill: "#E20D18"
    }),
    React.createElement("path", {
      d: "m18.200196,32.25l-6.2,0c-0.5,0 -0.9,-0.4 -0.9,-0.9l0,-19.7c0,-0.5 0.4,-0.9 0.9,-0.9l6.2,0c0.5,0 0.9,0.4 0.9,0.9l0,19.7c0,0.5 -0.4,0.9 -0.9,0.9z",
      fill: "#FFFFFF"
    }),
    React.createElement("path", {
      d: "m31.000196,32.3l-6.2,0c-0.5,0 -0.9,-0.4 -0.9,-0.9l0,-19.8c0,-0.5 0.4,-0.9 0.9,-0.9l6.2,0c0.5,0 0.9,0.4 0.9,0.9l0,19.7c0,0.6 -0.4,1 -0.9,1z",
      fill: "#FFFFFF"
    })
  );
}

function IconRGSelfTest() {
  return React.createElement(
    "svg",
    { viewBox: "0 0 43 43", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { y2: ".502", x2: "-.112", y1: ".502", x1: "1.112", id: "selftest" },
        React.createElement("stop", { stopColor: "#E41913", offset: "0" }),
        React.createElement("stop", { stopColor: "#EA6516", offset: ".097" }),
        React.createElement("stop", { stopColor: "#F3A518", offset: ".215" }),
        React.createElement("stop", { stopColor: "#F9CD1A", offset: ".312" }),
        React.createElement("stop", { stopColor: "#FDE31A", offset: ".384" }),
        React.createElement("stop", { stopColor: "#FEEB1A", offset: ".423" }),
        React.createElement("stop", { stopColor: "#DFDE20", offset: ".623" }),
        React.createElement("stop", { stopColor: "#009245", offset: "1" })
      )
    ),
    React.createElement("path", {
      d: "M21.35 42.35c-5.5-.1-10.7-2.3-14.6-6.2-3.9-4-6-9.2-5.9-14.8.1-11.3 9.4-20.6 20.8-20.6h.2c5.5.1 10.7 2.3 14.6 6.2 3.9 4 6 9.2 5.9 14.8-.1 11.3-9.4 20.6-20.8 20.6h-.2z",
      fill: "#FFF"
    }),
    React.createElement("path", {
      d: "M21.55.25v1h.2c5.4.1 10.5 2.2 14.3 6.1 3.8 3.9 5.8 9 5.8 14.4-.1 11.1-9.2 20.1-20.3 20.1h-.2c-5.4-.1-10.5-2.2-14.3-6.1-3.8-3.9-5.8-9-5.8-14.4.1-11.1 9.2-20.1 20.3-20.1v-1m0 0c-11.6 0-21.1 9.4-21.3 21-.1 11.7 9.3 21.4 21 21.5h.2c11.6 0 21.1-9.4 21.3-21 .1-11.7-9.3-21.4-21-21.5h-.2z",
      fill: "#020203"
    }),
    React.createElement("path", {
      d: "M36.7 21.25c-2.2-18.6-27.8-19-30.4 0",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeWidth: "6.774",
      stroke: "url(#selftest)",
      fill: "none"
    }),
    React.createElement("path", {
      d: "M17.182 21.85l8.8-15.8-1.8 18c-.6 1.9-2.7 3-4.6 2.4s-3-2.7-2.4-4.6z",
      fill: "#1E1E1C"
    })
  );
}

function IconExternalLink() {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 16" },
    React.createElement(
      "g",
      { fill: "currentColor" },
      React.createElement("path", { d: "M14.286 9.322h-.665a.322.322 0 0 0-.332.332v3.322a1.6 1.6 0 0 1-.488 1.174 1.6 1.6 0 0 1-1.173.487H2.99a1.6 1.6 0 0 1-1.173-.487 1.6 1.6 0 0 1-.488-1.174V4.34a1.6 1.6 0 0 1 .488-1.174 1.6 1.6 0 0 1 1.173-.487h7.309a.324.324 0 0 0 .239-.094.323.323 0 0 0 .093-.239v-.664a.323.323 0 0 0-.093-.239.323.323 0 0 0-.24-.093H2.99a2.88 2.88 0 0 0-2.113.877A2.88 2.88 0 0 0 0 4.339v8.638c0 .823.292 1.527.877 2.112a2.88 2.88 0 0 0 2.113.878h8.638a2.88 2.88 0 0 0 2.113-.878 2.879 2.879 0 0 0 .877-2.112V9.654a.323.323 0 0 0-.094-.238.323.323 0 0 0-.238-.094z" }),
      React.createElement("path", { d: "M18.407.217A.639.639 0 0 0 17.94.02h-5.316a.638.638 0 0 0-.467.197.638.638 0 0 0-.197.467c0 .18.066.336.197.468l1.827 1.827-6.769 6.769a.328.328 0 0 0 0 .477L8.4 11.41a.328.328 0 0 0 .478 0l6.769-6.77 1.827 1.828a.638.638 0 0 0 .467.197c.18 0 .336-.065.467-.197A.638.638 0 0 0 18.605 6V.684a.639.639 0 0 0-.198-.467z" })
    )
  );
}

var Wrapper = _styled('span', {
  target: 'ekf8n880'
})('display:inline-flex;justify-content:center;align-items:center;vertical-align:bottom;font-size:inherit;', function (props) {
  return props.color && 'color: ' + props.color;
}, ';', function (props) {
  return props.size && 'font-size: ' + props.size;
}, ';', function (props) {
  return props.onClick && 'cursor: pointer';
}, ';' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb24td3JhcHBlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLMkIiLCJmaWxlIjoiaWNvbi13cmFwcGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHZlcnRpY2FsLWFsaWduOiBib3R0b207XG4gIGZvbnQtc2l6ZTogaW5oZXJpdDtcblxuICAke3Byb3BzID0+IHByb3BzLmNvbG9yICYmIGBjb2xvcjogJHtwcm9wcy5jb2xvcn1gfTtcbiAgJHtwcm9wcyA9PiBwcm9wcy5zaXplICYmIGBmb250LXNpemU6ICR7cHJvcHMuc2l6ZX1gfTtcbiAgJHtwcm9wcyA9PiBwcm9wcy5vbkNsaWNrICYmICdjdXJzb3I6IHBvaW50ZXInfTtcbmBcblxuY29uc3QgU3ZnSWNvbiA9IHN0eWxlZC5zdmdgXG4gIHdpZHRoOiAxZW07XG4gIGhlaWdodDogMWVtO1xuYFxuXG5mdW5jdGlvbiBJY29uV3JhcHBlcihwcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxXcmFwcGVyXG4gICAgICBjb2xvcj17cHJvcHMuY29sb3J9XG4gICAgICBjbGFzc05hbWU9e3Byb3BzLmNsYXNzTmFtZX1cbiAgICAgIHNpemU9e3Byb3BzLnNpemV9XG4gICAgICBvbkNsaWNrPXtwcm9wcy5vbkNsaWNrfVxuICAgID5cbiAgICAgIDxTdmdJY29uPntwcm9wcy5jaGlsZHJlbn08L1N2Z0ljb24+XG4gICAgPC9XcmFwcGVyPlxuICApXG59XG5cbkljb25XcmFwcGVyLnByb3BUeXBlcyA9IHtcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5lbGVtZW50LmlzUmVxdWlyZWQsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgY29sb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIG9uQ2xpY2s6IFByb3BUeXBlcy5mdW5jLFxufVxuXG5leHBvcnQgeyBJY29uV3JhcHBlciB9XG4iXX0= */'));

var SvgIcon = _styled('svg', {
  target: 'ekf8n881'
})(process.env.NODE_ENV === 'production' ? {
  name: '1m3x3v9',
  styles: 'width:1em;height:1em;'
} : {
  name: '1m3x3v9',
  styles: 'width:1em;height:1em;',
  map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb24td3JhcHBlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQjBCIiwiZmlsZSI6Imljb24td3JhcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IFdyYXBwZXIgPSBzdHlsZWQuc3BhbmBcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB2ZXJ0aWNhbC1hbGlnbjogYm90dG9tO1xuICBmb250LXNpemU6IGluaGVyaXQ7XG5cbiAgJHtwcm9wcyA9PiBwcm9wcy5jb2xvciAmJiBgY29sb3I6ICR7cHJvcHMuY29sb3J9YH07XG4gICR7cHJvcHMgPT4gcHJvcHMuc2l6ZSAmJiBgZm9udC1zaXplOiAke3Byb3BzLnNpemV9YH07XG4gICR7cHJvcHMgPT4gcHJvcHMub25DbGljayAmJiAnY3Vyc29yOiBwb2ludGVyJ307XG5gXG5cbmNvbnN0IFN2Z0ljb24gPSBzdHlsZWQuc3ZnYFxuICB3aWR0aDogMWVtO1xuICBoZWlnaHQ6IDFlbTtcbmBcblxuZnVuY3Rpb24gSWNvbldyYXBwZXIocHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8V3JhcHBlclxuICAgICAgY29sb3I9e3Byb3BzLmNvbG9yfVxuICAgICAgY2xhc3NOYW1lPXtwcm9wcy5jbGFzc05hbWV9XG4gICAgICBzaXplPXtwcm9wcy5zaXplfVxuICAgICAgb25DbGljaz17cHJvcHMub25DbGlja31cbiAgICA+XG4gICAgICA8U3ZnSWNvbj57cHJvcHMuY2hpbGRyZW59PC9TdmdJY29uPlxuICAgIDwvV3JhcHBlcj5cbiAgKVxufVxuXG5JY29uV3JhcHBlci5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMuZWxlbWVudC5pc1JlcXVpcmVkLFxuICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbn1cblxuZXhwb3J0IHsgSWNvbldyYXBwZXIgfVxuIl19 */'
});

function IconWrapper(props) {
  return React.createElement(
    Wrapper,
    {
      color: props.color,
      className: props.className,
      size: props.size,
      onClick: props.onClick
    },
    React.createElement(
      SvgIcon,
      null,
      props.children
    )
  );
}

IconWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func
};

exports.IconAlert = IconAlert;
exports.IconBlitz = IconBlitz;
exports.IconBell = IconBell;
exports.IconBellPressed = IconBellPressed;
exports.IconCaretDown = IconCaretDown;
exports.IconCheck = IconCheck;
exports.IconChevronDown = IconChevronDown;
exports.IconChevronLeft = IconChevronLeft;
exports.IconChevronRight = IconChevronRight;
exports.IconChevronUp = IconChevronUp;
exports.IconPlus = IconPlus;
exports.IconMinus = IconMinus;
exports.IconCheckCircle = IconCheckCircle;
exports.IconCheckCircleEmpty = IconCheckCircleEmpty;
exports.IconCrown = IconCrown;
exports.IconCurrencyEur = IconCurrencyEur;
exports.IconCurrencyGbp = IconCurrencyGbp;
exports.IconCurrencyNok = IconCurrencyNok;
exports.IconCurrencySek = IconCurrencySek;
exports.IconCurrencyUsd = IconCurrencyUsd;
exports.IconClose = IconClose;
exports.IconClock = IconClock;
exports.IconEye = IconEye;
exports.IconEyeSlash = IconEyeSlash;
exports.IconFlagFinland = IconFlagFinland;
exports.IconFlagGermany = IconFlagGermany;
exports.IconFlagGreatBritain = IconFlagGreatBritain;
exports.IconFlagNorway = IconFlagNorway;
exports.IconFlagSweden = IconFlagSweden;
exports.IconFullscreen = IconFullscreen;
exports.IconHome = IconHome;
exports.IconInfo = IconInfo;
exports.IconMagnifyingGlass = IconMagnifyingGlass;
exports.IconTimes = IconTimes;
exports.IconNavigation = IconNavigation;
exports.IconDealer = IconDealer;
exports.IconRoulette = IconRoulette;
exports.IconRGLimits = IconRGLimits;
exports.IconRGPause = IconRGPause;
exports.IconRGSelfTest = IconRGSelfTest;
exports.IconExternalLink = IconExternalLink;
exports.IconWrapper = IconWrapper;
//# sourceMappingURL=index.js.map
